<template>
  <main class="login-page">
    <section class="login-visual" aria-label="Zaturday introduction">
      <div class="login-message">
        <p>Any Day is Zaturday</p>
        <h1>Manage your spaces and meetings<br />with clarity and confidence.</h1>
      </div>
    </section>

    <section class="login-panel" aria-label="Sign in">
      <v-card class="login-card" elevation="0">
        <v-card-text class="login-card__content">
          <div class="login-logo">
            <img
              src="@/assets/login-logo.png"
              alt="Zaturday"
              loading="eager"
              fetchpriority="high"
            />
          </div>
          <p class="login-tagline">Smart room booking platform</p>

          <form class="login-form" @submit.prevent="Login">
            <label class="login-label" for="username">User Name</label>
            <v-text-field
              id="username"
              v-model="username"
              class="login-input"
              placeholder="Enter your username"
              name="login"
              type="text"
              autocomplete="username"
              outlined
              hide-details
            />

            <label class="login-label login-label--password" for="password"
              >Password</label
            >
            <v-text-field
              id="password"
              v-model="password"
              class="login-input login-input--password"
              placeholder="Enter your password"
              :append-icon="ShowPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="ShowPassword ? 'text' : 'password'"
              autocomplete="current-password"
              outlined
              hide-details
              @click:append="ShowPassword = !ShowPassword"
            />

            <v-btn
              class="login-button"
              type="submit"
              block
              color="#00368e"
              :disabled="isLoginLocked"
              :loading="LoadingDialog"
              x-large
            >
              Sign In
            </v-btn>
          </form>
        </v-card-text>
      </v-card>
    </section>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "Login",
  data() {
    return {
      model: "tab-1",
      url: enurl.apiUrl,
      LoadingDialog: false,

      flagPassword: false,
      username: "",
      password: "",
      ShowPassword: false,
      ShowRePassword: false,
      isLoginLocked: false,
    };
  },

  mounted() {
    window.addEventListener("keydown", this.handleLoginEnter);
    this.tokenInterval = setInterval(() => {
      const token = this.$cookies.get("Token");
      if (token) {
        this.$store.dispatch("CheckToken", { token });
      }
    }, 10 * 1000);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleLoginEnter);
    if (this.tokenInterval) clearInterval(this.tokenInterval);
  },

  methods: {
    showLoginAlert(options) {
      return Swal.fire(options).then((result) => {
        this.isLoginLocked = false;
        return result;
      });
    },

    handleLoginEnter(event) {
      if (event.key !== "Enter") return;
      if (event.target?.closest?.(".swal2-container")) return;
      if (this.LoadingDialog || this.isLoginLocked || Swal.isVisible()) return;

      this.Login();
    },

    Login() {
      let self = this;
      if (self.isLoginLocked || Swal.isVisible()) return;

      self.isLoginLocked = true;
      if (!self.username || !self.password) {
        self.showLoginAlert("กรุณากรอกข้อมูลให้ครบถ้วน !");
      } else {
        self.LoadingDialog = true;
        let temp = {
          Username: self.username,
          Password: self.password,
        };
        self.$store
          .dispatch("LoginUser", temp)
          .then(function (response) {
            if (response.data.status == 0) {
              const role = response.data.data.roleID;
              localStorage.setItem("Token", response.data.data.token);
              localStorage.setItem("roleID", role);

              axios.defaults.headers.common["Authorization"] =
                "Bearer " + response.data.data.token;
              if (role == 3) {
                self.$router.replace("/MeetingRoomScreen");
              } else {
                const redirect = self.$route.query.redirect;
                const safeRedirect =
                  typeof redirect === "string" &&
                  redirect.startsWith("/") &&
                  !redirect.startsWith("//")
                    ? redirect
                    : "/Dashboard";
                self.$router.replace(safeRedirect);
              }
            }
          })
          .catch(function (error) {
            const message =
              error?.response?.data?.message ||
              error?.response?.data?.Message ||
              error?.data?.message ||
              error?.data?.Message ||
              error?.message ||
              "Login failed";

            self.LoadingDialog = false;
            return self.showLoginAlert({
              icon: "error",
              width: 500,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
            if (!Swal.isVisible()) {
              self.isLoginLocked = false;
            }
          });
      }
    },

    CheckDuplicateUsername(username) {
      let self = this;
      if (!username) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        self.LoadingDialog = true;
        let temp = {
          Username: username,
        };
        axios
          .post(`${self.url}Login/CheckDuplicateUsername`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.LoadingDialog = false;
              if (response.data.data.isDuplicate) {
                self.LoadingDialog = false;
                Swal.fire({
                  icon: "warning",
                  width: 500,
                  text: "Username : " + username + " ซ้ำกับในระบบ",
                });
              } else {
                self.LoadingDialog = false;
                Swal.fire({
                  icon: "success",
                  width: 500,
                  text: "Username : " + username + " สามารถใช้งานได้",
                });
              }
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            const message =
              error?.response?.data?.message ||
              error?.message ||
              "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

            Swal.fire({
              icon: "warning",
              width: 900,
              text: message,
            });
          });
      }
    },

    OpenRegisterDialog() {
      let self = this;
      self.ClearDataRegister();
      self.RegisterDialog = true;
    },

    ClearDataRegister() {
      let self = this;
      self.Username_Register = "";
      self.Password_Register = "";
      self.RePassword_Register = "";
      self.Firstname_Register = "";
      self.Lastname_Register = "";
      self.Telephone_Register = "";
      self.Email_Register = "";
    },

    CloseRegisterDialog() {
      let self = this;
      self.ClearDataRegister();
      self.RegisterDialog = false;
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        self.flagPassword = false;
      } else {
        x.type = "password";
        self.flagPassword = true;
      }
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Inter";
  src: url("~@/assets/Font/Inter-VariableFont_opsz,wght.ttf") format("truetype");
  font-display: swap;
}

.login-page {
  display: grid;
  grid-template-columns: 51.5625% 48.4375%;
  min-height: 1080px;
  background: #ffffff;
  font-family: "Inter", Arial, sans-serif;
}

.login-visual {
  position: relative;
  min-height: 1080px;
  overflow: hidden;
  background: #dce9f7;
}

.login-visual::before {
  position: absolute;
  top: -62.24%;
  left: 0.01%;
  width: 100%;
  height: 204.77%;
  content: "";
  background: url("~@/assets/login-background.jpg") center / 100% 100% no-repeat;
  opacity: 0.9;
}

.login-visual::after {
  content: none;
}

.login-message {
  position: absolute;
  z-index: 1;
  right: 109px;
  bottom: 80px;
  left: 78px;
  color: #ffffff;
}

.login-message p {
  margin: 0 0 22px;
  color: #ffffff;
  font-size: 25.552px;
  font-weight: 500;
  opacity: 0.5;
}

.login-message h1 {
  max-width: 803px;
  margin: 0;
  font-size: 45.297px;
  font-weight: 500;
  letter-spacing: -0.025em;
  line-height: 1.3;
  text-wrap: balance;
}

.login-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 1080px;
  padding: 0;
}

.login-card {
  width: min(100%, 480px);
  height: 569px;
  overflow: hidden;
  border-radius: 20px !important;
  background: rgba(250, 250, 250, 0.8) !important;
  box-shadow: 0 8px 12px rgba(54, 53, 53, 0.2) !important;
  transform: translateX(-25px);
}

.login-card__content {
  position: relative;
  height: 100%;
  padding: 0 !important;
}

.login-logo {
  position: absolute;
  top: 49px;
  left: 137.5px;
  width: 205px;
  height: 34.867px;
  overflow: hidden;
}

.login-logo img {
  position: absolute;
  top: -131.06px;
  left: -116.46px;
  width: 430.17px;
  height: 304.14px;
  max-width: none;
}

.login-tagline {
  position: absolute;
  top: 83.93px;
  right: 174px;
  left: 138px;
  margin: 0;
  color: #000000;
  font-size: 11.847px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  white-space: nowrap;
}

.login-form {
  position: absolute;
  top: 177.87px;
  right: 51px;
  left: 51px;
  display: flex;
  flex-direction: column;
}

.login-label {
  margin-bottom: 6px;
  color: rgba(25, 28, 30, 0.9);
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
}

.login-label--password {
  margin-top: 23px;
}

.login-input ::v-deep .v-input__slot {
  min-height: 48px !important;
  padding: 0 17px !important;
  border-radius: 30px !important;
  background: rgba(0, 0, 0, 0.02) !important;
}

.login-input ::v-deep fieldset {
  border-color: rgba(194, 198, 214, 0.3) !important;
}

.login-input ::v-deep input {
  color: #191c1e;
  font-size: 16px;
}

.login-input ::v-deep input::placeholder {
  color: rgba(194, 198, 214, 0.7);
  opacity: 1;
}

.login-input ::v-deep .v-icon {
  color: #00368e;
  font-size: 18.333px;
}

.login-input--password ::v-deep .v-input__append-inner {
  align-self: center;
  margin-top: 0;
}

.login-input ::v-deep .v-input__slot:hover fieldset,
.login-input ::v-deep .v-input__slot:focus-within fieldset {
  border-color: #07459f !important;
}

.login-button {
  height: 52px !important;
  margin-top: 40px;
  border-radius: 30px !important;
  color: #ffffff !important;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  transition: background-color 180ms ease-out, transform 180ms ease-out;
}

@media (min-width: 961px) {
  .login-page,
  .login-visual,
  .login-panel {
    min-height: max(720px, 100vh);
  }

  .login-card {
    width: 432px;
    height: 512px;
    transform: translateX(-22px);
  }

  .login-card__content {
    width: 111.111%;
    height: 111.111%;
    transform: scale(0.9);
    transform-origin: top left;
  }

  .login-message {
    right: 98px;
    bottom: 72px;
    left: 70px;
  }

  .login-message p {
    margin-bottom: 20px;
    font-size: 23px;
  }

  .login-message h1 {
    max-width: 723px;
    font-size: 41px;
  }
}

.login-button:hover {
  background-color: #063b88 !important;
}

.login-button:active {
  transform: translateY(1px);
}

@media (max-width: 960px) {
  .login-page {
    grid-template-columns: 1fr;
    min-height: 100vh;
  }

  .login-visual {
    display: none;
  }

  .login-panel {
    min-height: 100vh;
    padding: 32px 20px;
    background: #eef4fb url("~@/assets/login-background.jpg") center / cover no-repeat;
  }

  .login-card {
    transform: none;
  }
}

@media (max-width: 600px) {
  .login-panel {
    align-items: stretch;
    padding: 0;
    background: #ffffff;
  }

  .login-card {
    width: 100%;
    height: auto;
    min-height: 100vh;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .login-card__content {
    padding: 36px 24px 48px !important;
  }

  .login-logo {
    margin-bottom: 32px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .login-button {
    transition: none;
  }
}
</style>
